<template>
     <div class="col-md-9" id="playlist-items" style="height: 150px;padding-top:0px">
                                <div class="not-found text-muted"><i class="las la-exclamation-circle"></i> No
                                    {{type}}s Found in Playlist</div>
                            </div>
            </div>

</template>


<script>
export default {
    name: 'empty-list',
    props: {
        playlist: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            default: 'Song'
        }
    }
}

</script>